export type PartyData = {
  acronym: string;
  name?: string;
  acronymAr?: string;
  color: string;
  seats: number;
  website?: string;
  socials?: {
    facebook?: string;
    twitter?: string;
    instagram?: string;
    youtube?: string;
  };
  symbol?: string;
  logoUrl?: string;
  jeunesseUrl?: string;
  femmesUrl?: string;
  academieUrl?: string;
  partyPrinciples?: { title: string; description: string; readMoreUrl?: string }[];
  programUrl?: string;
  presentationUrl?: string;
};

// Partis représentés au Parlement (élections 2021)
export const majorParties: PartyData[] = [
  { acronym: "RNI", name: "Rassemblement National des Indépendants", acronymAr: "الأحرار", color: "hsl(220 60% 50%)", seats: 102, website: "https://www.rni.ma", socials: { facebook: "https://facebook.com/RNIMaroc", twitter: "https://twitter.com/RNI_Maroc", instagram: "https://instagram.com/rni_maroc", youtube: "https://youtube.com/user/RNIMaroc" }, symbol: "🕊️", logoUrl: "/images/parties/RASSEMBLEMENT_NATIONAL_DES_INDEPENDANTS__R.N.I__.png", academieUrl: "https://academy.rni.ma/wp-login.php?redirect_to=https%3A%2F%2Facademy.rni.ma%2F", programUrl: "https://www.rni.ma/programme-2021/", presentationUrl: "https://www.rni.ma/qui-sommes-nous/" },
  { acronym: "PAM", name: "Parti Authenticité et Modernité", acronymAr: "البام", color: "hsl(30 80% 50%)", seats: 87, website: "https://www.pam.ma", socials: { facebook: "https://facebook.com/PAM.Maroc", instagram: "https://instagram.com/pam_maroc" }, symbol: "🚜", logoUrl: "/images/parties/PARTI_AUTHENTICITE_ET_MODERNITE__PAM_.png", jeunesseUrl: "https://pam.ma/fr/%D9%85%D9%86%D8%B8%D9%85%D8%A9-%D8%A7%D9%84%D8%B4%D8%A8%D8%A7%D8%A8/", femmesUrl: "https://pam.ma/fr/%D9%85%D9%86%D8%B8%D9%85%D8%A9-%D9%86%D8%B3%D8%A7%D8%A1-%D8%A7%D9%84%D8%AD%D8%B2%D8%A8/", programUrl: "https://pam.ma/fr/programme-electoral-2021/", presentationUrl: "https://pam.ma/fr/qui-sommes-nous/" },
  { acronym: "PI", name: "Parti de l'Istiqlal", acronymAr: "الاستقلال", color: "hsl(150 60% 35%)", seats: 81, website: "https://www.istiqlal.ma", socials: { facebook: "https://facebook.com/PartiIstiqlal", twitter: "https://twitter.com/PartiIstiqlal" }, symbol: "⚖️", logoUrl: "/images/parties/PARTI_DE_L_ISTIQLAL__P.I_.png", programUrl: "https://www.istiqlal.ma/programme-2021", presentationUrl: "https://www.istiqlal.ma/histoire" },
  { acronym: "USFP", name: "Union Socialiste des Forces Populaires", acronymAr: "الاتحاد الاشتراكي", color: "hsl(350 70% 50%)", seats: 34, website: "https://www.usfp.ma", socials: { facebook: "https://facebook.com/usfp.ma" }, symbol: "🌹", logoUrl: "/images/parties/UNION_SOCIALISTE_DES_FORCES_POPULAIRES__U.S.F.P__.png", programUrl: "https://www.usfp.ma/notre-programme", presentationUrl: "https://www.usfp.ma/histoire-du-parti" },
  { acronym: "MP", name: "Mouvement Populaire", acronymAr: "الحركة الشعبية", color: "hsl(100 50% 40%)", seats: 28, website: "https://www.mp.ma", socials: { facebook: "https://facebook.com/partiMP" }, symbol: "🌾", logoUrl: "/images/parties/Mouvement-populaire.png", programUrl: "https://www.mp.ma/programme", presentationUrl: "https://www.mp.ma/presentation" },
  { acronym: "PPS", name: "Parti du Progrès et du Socialisme", acronymAr: "التقدم والاشتراكية", color: "hsl(0 80% 45%)", seats: 22, website: "https://www.pps.ma", socials: { facebook: "https://facebook.com/pps.maroc", youtube: "https://youtube.com/c/PPSMaroc" }, symbol: "📖", logoUrl: "/images/parties/PARTI_DU_PROGRES_ET_DU_SOCIALISME__P.P.S__.png", programUrl: "https://www.pps.ma/programme-electoral/", presentationUrl: "https://www.pps.ma/notre-identite/" },
  { acronym: "UC", name: "Union Constitutionnelle", acronymAr: "الاتحاد الدستوري", color: "hsl(210 70% 45%)", seats: 18, website: "https://www.uc.ma", socials: { facebook: "https://facebook.com/partiuc" }, symbol: "🐎", logoUrl: "/images/parties/UNION_CONSTITUTIONNELLE__U.C__.png", programUrl: "https://www.uc.ma/programme", presentationUrl: "https://www.uc.ma/qui-sommes-nous" },
  { acronym: "PJD", name: "Parti de la Justice et du Développement", acronymAr: "العدالة والتنمية", color: "hsl(45 70% 45%)", seats: 13, website: "https://www.pjd.ma", socials: { facebook: "https://facebook.com/pjd.ma", twitter: "https://twitter.com/PJDI_Maroc", youtube: "https://youtube.com/user/pjdmaroc" }, symbol: "💡", logoUrl: "/images/parties/PARTI_DE_LA_JUSTICE_ET_DU_DEVELOPPEMENT__P.J.D__.png", programUrl: "https://www.pjd.ma/programme", presentationUrl: "https://www.pjd.ma/histoire" },
];

export const otherParties: PartyData[] = [
  { acronym: "MDS", name: "Mouvement Démocratique et Social", color: "hsl(280 50% 50%)", seats: 5, symbol: "🌴", logoUrl: "/images/parties/image12.jpeg" },
  { acronym: "FFD", name: "Front des Forces Démocratiques", color: "hsl(180 50% 40%)", seats: 3, symbol: "🌿", logoUrl: "/images/parties/PARTI_DU_FRONT_DES_FORCES_DEMOCRATIQUES__F.F.D_.jpg" },
  { acronym: "UMD", name: "Union Marocaine pour la Démocratie", color: "hsl(60 60% 45%)", seats: 1, symbol: "☂️", logoUrl: "/images/parties/_______________________________.jpg" },
  { acronym: "PAI", name: "Parti de l'Avant-garde et de l'Indépendance", color: "hsl(320 50% 45%)", seats: 1, symbol: "🦅", logoUrl: "/images/parties/________________________________.png" },
];

// Partis politiques non représentés au Parlement mais légalement constitués
export const nonParliamentaryParties: PartyData[] = [
  { acronym: "PE", color: "hsl(0 80% 45%)", seats: 0, symbol: "🍎", logoUrl: "/images/parties/image29.jpeg" }, // Parti de l'Equité
  { acronym: "PML", color: "hsl(270 45% 50%)", seats: 0, symbol: "🦁", logoUrl: "/images/parties/image50.jpeg" }, // Parti Marocain Libéral
  { acronym: "PVM", color: "hsl(160 50% 45%)", seats: 0, symbol: "⚖️", logoUrl: "/images/parties/image42.jpeg" }, // Parti des Verts Marocains
  { acronym: "Neo-Democrates", color: "hsl(230 50% 50%)", seats: 0, symbol: "👍", logoUrl: "/images/parties/PARTI_DES_NEO-DEMOCRATES.jpg" }, // Parti des Néo-Démocrates (Néo-Démocrates)
  { acronym: "PA", color: "hsl(25 80% 50%)", seats: 0, symbol: "🏃", logoUrl: "/images/parties/_________.png" }, // Parti de l'Action
  { acronym: "Al Amal", color: "hsl(200 60% 50%)", seats: 0, symbol: "✈️", logoUrl: "/images/parties/logo_al_amal.png" }, // Parti Al Amal
  { acronym: "PFC", color: "hsl(320 60% 40%)", seats: 0, symbol: "⛺", logoUrl: "/images/parties/PARTI_DES_FORCES_CITOYENNES__P.F.C_.png" }, // Parti des Forces Citoyennes
  { acronym: "PRE", color: "hsl(140 60% 40%)", seats: 0, symbol: "🍎", logoUrl: "/images/parties/pe2" }, // Parti du Renouveau et de l'Equité
  { acronym: "PS", color: "hsl(350 70% 60%)", seats: 0, symbol: "🌹", logoUrl: "/images/parties/image38.jpeg" }, // Parti Socialiste
  { acronym: "Annahda", color: "hsl(50 80% 45%)", seats: 0, symbol: "☀️", logoUrl: "/images/parties/PARTI_ANNAHDA.png" }, // Parti Annahda
  { acronym: "PGV", color: "hsl(140 45% 45%)", seats: 0, symbol: "🍃", logoUrl: "/images/parties/image44.jpeg" }, // Parti de la Gauche Verte
  { acronym: "PSU", color: "hsl(350 55% 45%)", seats: 0, symbol: "🕯️", logoUrl: "/images/parties/PARTI_SOCIALISTE_UNIFIE__P.S.U__.png" },
  { acronym: "PT", color: "hsl(5 65% 50%)", seats: 0, symbol: "⚒️", logoUrl: "/images/parties/image37.jpeg" },
  { acronym: "PRV", color: "hsl(140 45% 45%)", seats: 0, symbol: "🌳", logoUrl: "/images/parties/PARTI_DE_LA_RENAISSANCE_ET_DE_LA_VERTU.png" },
  { acronym: "PEDD", color: "hsl(120 55% 40%)", seats: 0, symbol: "🌍", logoUrl: "/images/parties/PARTI_DE_LENVIRONNEMENT_ET_DU_DEVELOPPEMENT_DURABLE.png" },
  { acronym: "CNI", color: "hsl(200 55% 45%)", seats: 0, symbol: "🤝", logoUrl: "/images/parties/___________________________.png" },
  { acronym: "PSD", color: "hsl(15 60% 50%)", seats: 0, symbol: "🎯", logoUrl: "/images/parties/image11.gif" },
  { acronym: "PDI", color: "hsl(260 45% 50%)", seats: 0, symbol: "⭐", logoUrl: "/images/parties/_____________________.jpeg" },
  { acronym: "PLJS", color: "hsl(40 55% 50%)", seats: 0, symbol: "⚖️", logoUrl: "/images/parties/unnamed.png" },
  { acronym: "PRD", color: "hsl(170 50% 40%)", seats: 0, symbol: "📈", logoUrl: "/images/parties/PARTI_DE_LA_REFORME_DU_DEVELOPPEMENT__P.R.D_.png" },
  { acronym: "PCS", color: "hsl(300 40% 50%)", seats: 0, symbol: "🤝", logoUrl: "/images/parties/particentresocial.jpg" },
  { acronym: "Al Ahd", color: "hsl(80 50% 40%)", seats: 0, symbol: "📜", logoUrl: "/images/parties/image32.png" },
  { acronym: "PUD", color: "hsl(195 55% 45%)", seats: 0, symbol: "🚰", logoUrl: "/images/parties/pud_logo.jpg" },
];

export const allParties = [...majorParties, ...otherParties];
export const allPartiesIncludingNonParliamentary = [...majorParties, ...otherParties, ...nonParliamentaryParties];
export const allSearchableParties = [...allPartiesIncludingNonParliamentary, { acronym: "SAP", color: "hsl(0 0% 50%)", seats: 0, symbol: "👤" }];

export const moroccoRegions = [
  {
    name: "Tanger-Tétouan-Al Hoceïma",
    nameAr: "طنجة-تطوان-الحسيمة",
    nameZgh: "ⵟⴰⵏⵊⴰ-ⵜⵉⵟⵟⴰⵡⵉⵏ-ⵍⵃⵓⵙⵉⵎⴰ",
    provinces: ["Tanger-Assilah", "M'diq-Fnideq", "Tétouan", "Fahs-Anjra", "Larache", "Al Hoceïma", "Chefchaouen", "Ouezzane"]
  },
  {
    name: "L'Oriental",
    nameAr: "الشرق",
    nameZgh: "ⴰⴳⵎⵓⴹ",
    provinces: ["Oujda-Angad", "Nador", "Driouch", "Jerada", "Berkane", "Taourirt", "Guercif", "Figuig"]
  },
  {
    name: "Fès-Meknès",
    nameAr: "فاس-مكناس",
    nameZgh: "ⴼⴰⵙ-ⵎⴽⵏⴰⵙ",
    provinces: ["Fès-Sud", "Fès-Nord", "Meknès", "El Hajeb", "Ifrane", "Moulay Yacoub", "Sefrou", "Boulemane", "Taounate-Tissa", "Karia-Ghafsay", "Taza"]
  },
  {
    name: "Rabat-Salé-Kénitra",
    nameAr: "الرباط-سلا-القنيطرة",
    nameZgh: "ⵕⴱⴰⵟ-ⵙⵍⴰ-ⵇⵏⵉⵟⵔⴰ",
    provinces: ["Rabat-Chellah", "Rabat-Océan", "Salé-Médina", "Salé-Jadida", "Skhirate-Témara", "Kénitra", "Gharb", "Khémisset-Oulmès", "Tiflet-Rommani", "Sidi Kacem", "Sidi Slimane"]
  },
  {
    name: "Béni Mellal-Khénifra",
    nameAr: "بني ملال-خنيفرة",
    nameZgh: "ⴰⵢⵜ ⵎⵍⵍⴰⵍ-ⵅⵏⵉⴼⵔⴰ",
    provinces: ["Béni Mellal", "Azilal-Demnate", "Bzou-Ouaouizeght", "Fquih Ben Salah", "Khénifra", "Khouribga"]
  },
  {
    name: "Casablanca-Settat",
    nameAr: "الدار البيضاء-سطات",
    nameZgh: "ⴰⵏⴼⴰ-ⵙⵟⵟⴰⵜ",
    provinces: ["Casablanca-Anfa", "Aïn Sebaâ-Hay Mohammadi", "Moulay Rachid", "Sidi Bernoussi", "Hay Hassani", "Al Fida-Mers Sultan", "Ben M'sik", "Aïn Chock", "Mohammédia", "El Jadida", "Settat", "Berrechid", "Benslimane", "Médiouna", "Nouaceur", "Sidi Bennour"]
  },
  {
    name: "Marrakech-Safi",
    nameAr: "مراكش-أسفي",
    nameZgh: "ⵎⵕⵕⴰⴽⵛ-ⴰⵙⴼⵉ",
    provinces: ["Gueliz-Nakhil", "Ménara", "Sidi Youssef Ben Ali", "Chichaoua", "Al Haouz", "Essaouira", "El Kelâa des Sraghna", "Rehamna", "Safi", "Youssoufia"]
  },
  {
    name: "Drâa-Tafilalet",
    nameAr: "درعة-تافيلالت",
    nameZgh: "ⴷⵔⵄⴰ-ⵜⴰⴼⵉⵍⴰⵍⵜ",
    provinces: ["Errachidia", "Ouarzazate", "Midelt", "Tinghir", "Zagora"]
  },
  {
    name: "Souss-Massa",
    nameAr: "سوس-ماسة",
    nameZgh: "ⵙⵓⵙ-ⵎⴰⵙⵙⴰ",
    provinces: ["Agadir-Ida Ou Tanane", "Inezgane-Aït Melloul", "Chtouka-Aït Baha", "Taroudant-Nord", "Taroudant-Sud", "Tiznit", "Tata"]
  },
  {
    name: "Guelmim-Oued Noun",
    nameAr: "كلميم-واد نون",
    nameZgh: "ⴳⵍⵎⵉⵎ-ⵡⴰⴷ ⵏⵓⵏ",
    provinces: ["Guelmim", "Assa-Zag", "Tan-Tan", "Sidi Ifni"]
  },
  {
    name: "Laâyoune-Sakia El Hamra",
    nameAr: "العيون-الساقية الحمراء",
    nameZgh: "ⵍⵄⵢⵓⵏ-ⵙⴰⵇⵢⴰ ⵍⵃⴰⵎⵔⴰ",
    provinces: ["Laâyoune", "Boujdour", "Tarfaya", "Es-Semara"]
  },
  {
    name: "Dakhla-Oued Ed-Dahab",
    nameAr: "الداخلة-وادي الذهب",
    nameZgh: "ⴷⴷⴰⵅⵍⴰ-ⵡⴰⴷ ⴷⴷⴰⵀⴰⴱ",
    provinces: ["Oued Ed-Dahab", "Aousserd"]
  },
];
